<template>
  <section class="register">
    <div class="box" style="max-width: 500px">
      <div class="header">
        <div class="title">Validação</div>
        <div @click="close" class="close"><i class="fas fa-times"></i></div>
      </div>
      <div class="messages-content">
        <div v-for="group in messages" :key="group.date" class="messages">
          <div class="message-date">{{ group.date }}</div>
          <div v-for="msg in group.messages" :key="msg.id" class="message" :class="role === msg.role ? 'from' : 'to'">
            <div>{{ msg.message }}</div>
            <div class="time">{{ getTimeMin(msg.date) }}</div>
          </div>
        </div>
      </div>
      <form @submit.prevent="sendMessage" class="form">
        <textarea v-model="message" placeholder="Digite a mensagem..."></textarea>
        <button type="submit">Enviar</button>
        <button v-if="role === 'admin'" @click="approve" type="button">Aprovar</button>
      </form>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { getMessages, create, approve } from '../api/showValidation'

export default {
  name: 'showValidation',

  props: ['showDate', 'role', 'close'],
  data () {
    return {
      messages: [],
      message: ''
    }
  },
  beforeMount () {
    this.getMessages()
  },
  methods: {
    async approve () {
      try {
        await approve(this.showDate)
        this.close()
      } catch (error) {
        logger.error(error, this)
      }
    },
    async sendMessage () {
      try {
        await create(this.showDate, this.message)
        this.message = ''
        this.getMessages()
      } catch (error) {
        logger.error(error, this)
      }
    },
    async getMessages () {
      try {
        const messages = await getMessages(this.showDate)
        this.messages = messages.reduce((acc, cur) => {
          const found = acc.find(x => x.date === this.getDate(cur.date))
          if (found) found.messages.push(cur)
          else acc.push({ date: this.getDate(cur.date), messages: [cur] })
          return acc
        }, [])
      } catch (error) {
        logger.error(error, this)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.messages-content {
  height: calc(100vh - 400px);
  min-height: 300px;
  margin: 0 15px;
  padding: 10px 15px;
  border: 1px solid #ccc;
  background-color: #f1f1f1;
  border-radius: 5px;
  overflow-y: auto;
  overflow-x: hidden;
}

.messages {
  display: flex;
  flex-direction: column;
}

.message-date {
  align-self: center;
  border-radius: 5px;
  border: 1px solid #ccc;
  color: #777;
  font-size: 0.8em;
  padding: 4px 10px;
  margin: 5px;
}

.message {
  border: 1px solid $primary-color;
  padding: 8px 10px;
  margin: 3px 0;
  font-size: 0.95em;
  .time {
    margin-top: 3px;
    font-size: 0.8em;
    text-align: right;
  }
  &.from {
    align-self: flex-end;
    background: linear-gradient(to bottom right, $primary-color, $secondary-color);
    color: #fff;
    border-radius: 8px 0 8px 8px;
  }
  &.to {
    align-self: flex-start;
    background: $hover-color;
    color: $primary-color;
    border-radius: 0 8px 8px 8px;
  }
}

.form {
  flex-direction: row;
  padding: 15px;
  textarea {
    flex-grow: 1;
    margin: 0;
  }
  button[type=submit] {
    font-size: 1em;
    background: linear-gradient(to bottom right, $primary-color, $secondary-color);
    color: #fff;
    border: 1px solid $primary-color;
    border-radius: 5px;
    margin-left: 5px;
    padding: 0 10px;
    cursor: pointer;
  }
  button[type=button] {
    font-size: 1em;
    font-weight: bold;
    background: #fff;
    color: $primary-color;
    border: 2px solid $primary-color;
    border-radius: 5px;
    margin-left: 5px;
    padding: 0 10px;
    cursor: pointer;
  }
}
</style>
